import React, { Fragment } from "react";
import Terms from "./compliance/Terms/Terms";
import Documentation from "./documentation/Documentation/Documentation";
import DownPaymentLoanAdjust from "./downPayment/DownPaymentLoanAdjust/DownPaymentLoanAdjust";
import BankReader from "./income/BankReader/BankReader";
import { CashInCashOutMethod } from "./income/CashInCashOutMethod/CashInCashOutMethod";
import DeclaredIncome from "./income/DeclaredIncome/DeclaredIncome";
import DeclaredIncomeOnConditions from "./income/DeclaredIncome/DeclaredIncomeOnConditions";
import { KycAutomatic } from "./kyc/KycAutomatic/KycAutomatic/KycAutomatic";
import KycDocumentNumberValidation from "./kyc/KycDocumentNumberValidation/KycDocumentNumberValidation";
import KycManual from "./kyc/KycManual/KycManual";
import ProfessionalData from "./kyc/ProfessionalData/ProfessionalData";
import SummaryAndAdjust from "./loanApplication/SummaryAndAdjust/SummaryAndAdjust";
import OptInsAndSignature from "./signature/Signature/OptInsAndSignature";
import SignatureUrlRedirect from "./signature/Signature/components/SignatureUrlRedirect";
import Disabled from "./welcome/Disabled/Disabled";
import Slider from "./welcome/Slider/Slider";
import VideoId from "./videoId/VideoId/VideoId";
import VideoIdResult from "./videoIdResult/VideoIdResult/VideoIdResult";
import SetBankAccountDetails from "./income/SetBankAccountDetails/SetBankAccountDetails";
import { KycAutomaticWithNieEu } from "./kyc/KycAutomatic/KycAutomaticWithNieEu/KycAutomaticWithNieEu";
import { ApplicationInfoFactory } from "./loanApplication/ApplicationInfo/ApplicationInfoFactory";
import { Card } from "./card/Card/Card";
import { ValidationLink } from "./validationLink/ValidationLink/ValidationLink";
import { QuotaAdjustment } from "./quotaAdjustment/QuotaAdjustment";
import { DocumentIdVerification } from "./idDocumentVerification/DocumentIdVerification";
import KycVideoVerification from "./kyc/KycVideoVerification/KycVideoVerification";

export const modules = {
  DISABLED: {
    id: "DISABLED",
  },
  SLIDER: {
    id: "SLIDER",
  },
  TERMS: {
    id: "TERMS",
  },
  DOWNPAYMENT_CALCULATOR: {
    id: "DOWNPAYMENT_CALCULATOR",
  },
  CARD: {
    id: "CARD",
  },
  DOCUMENT_ID_VERIFICATION: {
    id: "DOCUMENT_ID_VERIFICATION",
  },
  FULL_KYC_AUTOMATIC: {
    id: "FULL_KYC_AUTOMATIC",
  },
  KYC_AUTOMATIC_WITH_NIE_EU: {
    id: "KYC_AUTOMATIC_WITH_NIE_EU",
  },
  KYC_MANUAL: {
    id: "KYC_MANUAL",
  },
  KYC_DOCUMENT_NUMBER_VALIDATION: {
    id: "KYC_DOCUMENT_NUMBER_VALIDATION",
  },
  BANK_READER: {
    id: "BANK_READER",
  },
  CASH_IN_CASH_OUT_METHOD: {
    id: "CASH_IN_CASH_OUT_METHOD",
  },
  SET_BANK_ACCOUNT_DETAILS: {
    id: "SET_BANK_ACCOUNT_DETAILS",
  },
  DECLARED_INCOME: {
    id: "DECLARED_INCOME",
  },
  PROFESSIONAL_DATA: {
    id: "PROFESSIONAL_DATA",
  },
  DECLARED_INCOME_ON_CONDITIONS: {
    id: "DECLARED_INCOME_ON_CONDITIONS",
  },
  SUMMARY_AND_ADJUST: {
    id: "SUMMARY_AND_ADJUST",
  },
  APPLICATION_INFO: {
    id: "APPLICATION_INFO",
  },
  DOCUMENTATION: {
    id: "DOCUMENTATION",
  },
  OPTINS_AND_SIGNATURE: {
    id: "OPTINS_AND_SIGNATURE",
  },
  SIGNATURE_URL_REDIRECT: {
    id: "SIGNATURE_URL_REDIRECT",
  },
  VIDEO_ID: {
    id: "VIDEO_ID",
  },
  VIDEO_ID_RESULT: {
    id: "VIDEO_ID_RESULT",
  },
  VALIDATION_LINK: {
    id: "VALIDATION_LINK",
  },
  QUOTA_ADJUSTMENT: {
    id: "QUOTA_ADJUSTMENT",
  },
  KYC_VIDEO_VERIFICATION: {
    id: "KYC_VIDEO_VERIFICATION",
  },
};

export default function ModuleRenderer({
  moduleId,
  hasKO,
  onOKOnlyResetKO,
  moduleProps,
}) {
  return (
    <Fragment>
      {moduleId === modules.DISABLED.id && <Disabled />}
      {moduleId === modules.SLIDER.id && <Slider />}
      {moduleId === modules.TERMS.id && <Terms />}
      {moduleId === modules.CARD.id && <Card />}
      {moduleId === modules.DOWNPAYMENT_CALCULATOR.id && (
        <DownPaymentLoanAdjust />
      )}
      {moduleId === modules.QUOTA_ADJUSTMENT.id && <QuotaAdjustment />}
      {moduleId === modules.DOCUMENT_ID_VERIFICATION.id && (
        <DocumentIdVerification />
      )}
      {moduleId === modules.FULL_KYC_AUTOMATIC.id && (
        <KycAutomatic {...moduleProps} />
      )}
      {moduleId === modules.KYC_AUTOMATIC_WITH_NIE_EU.id && (
        <KycAutomaticWithNieEu {...moduleProps} />
      )}
      {moduleId === modules.KYC_MANUAL.id && <KycManual {...moduleProps} />}
      {moduleId === modules.KYC_DOCUMENT_NUMBER_VALIDATION.id && (
        <KycDocumentNumberValidation />
      )}
      {moduleId === modules.BANK_READER.id && <BankReader {...moduleProps} />}
      {moduleId === modules.CASH_IN_CASH_OUT_METHOD.id && (
        <CashInCashOutMethod {...moduleProps} />
      )}
      {moduleId === modules.DECLARED_INCOME.id && (
        <DeclaredIncome {...moduleProps} />
      )}
      {moduleId === modules.DECLARED_INCOME_ON_CONDITIONS.id && (
        <DeclaredIncomeOnConditions {...moduleProps} />
      )}
      {moduleId === modules.SET_BANK_ACCOUNT_DETAILS.id && (
        <SetBankAccountDetails {...moduleProps} />
      )}
      {moduleId === modules.PROFESSIONAL_DATA.id && (
        <ProfessionalData {...moduleProps} />
      )}
      {moduleId === modules.SUMMARY_AND_ADJUST.id && (
        <SummaryAndAdjust {...moduleProps} />
      )}
      {moduleId === modules.APPLICATION_INFO.id && (
        <ApplicationInfoFactory {...moduleProps} />
      )}
      {moduleId === modules.DOCUMENTATION.id && <Documentation />}
      {moduleId === modules.OPTINS_AND_SIGNATURE.id && <OptInsAndSignature />}
      {moduleId === modules.SIGNATURE_URL_REDIRECT.id && (
        <SignatureUrlRedirect />
      )}
      {moduleId === modules.VIDEO_ID.id && <VideoId />}
      {moduleId === modules.KYC_VIDEO_VERIFICATION.id && (
        <KycVideoVerification {...moduleProps} />
      )}
      {moduleId === modules.VIDEO_ID_RESULT.id && <VideoIdResult />}
      {moduleId === modules.VALIDATION_LINK.id && <ValidationLink />}
    </Fragment>
  );
}
